import { $ } from './utils.js';
import { T, lang, registerTermsOverlay, registerPrivacyOverlay } from './i18n.js';

/* ─── Terms overlay ────────────────────── */
const termsOverlay = $('#terms-overlay');
const termsBody = $('#terms-body');
const termsSections = [
	{ t: 'terms1t', p: ['terms1', 'terms1details'] },
	{ t: 'terms2t', p: ['terms2'] },
	{ t: 'terms3t', p: ['terms3a', 'terms3b', 'terms3c', 'terms3d', 'terms3e'] },
	{ t: 'terms4t', p: ['terms4', 'terms4b'] },
	{ t: 'terms5t', p: ['terms5'] },
	{ t: 'terms6t', p: ['terms6'] },
	{ t: 'terms7t', p: ['terms7'] },
	{ t: 'terms8t', p: ['terms8'] },
	{ t: 'terms9t', p: ['terms9'] },
	{ t: 'terms10t', p: ['terms10'] },
];

export function renderTerms() {
	const l = lang;
	termsBody.innerHTML = termsSections.map(s => {
		const heading = T[l]?.[s.t] || s.t;
		const paras = s.p.map(k => {
			const text = (T[l]?.[k] || k).replace(/\n/g, '<br>');
			return '<p style="margin:0.5rem 0;color:var(--on-surface-secondary);">' + text + '</p>';
		}).join('');
		return '<div style="margin-bottom:1.75rem;"><h3 style="font-family:var(--font-heading);font-size:1.1rem;color:var(--on-surface);margin-bottom:0.5rem;">' + heading + '</h3>' + paras + '</div>';
	}).join('');
}

export function openTerms() {
	renderTerms();
	termsOverlay.style.display = 'block';
	document.body.style.overflow = 'hidden';
}
export function closeTerms() {
	termsOverlay.style.display = 'none';
	document.body.style.overflow = '';
	if (location.hash === '#terms') history.pushState(null, '', location.pathname + location.search);
}

$('#terms-close').addEventListener('click', closeTerms);
termsOverlay.addEventListener('click', e => { if (e.target === termsOverlay) closeTerms(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape' && termsOverlay.style.display === 'block') closeTerms(); });

// Register with i18n so applyLang can re-render when open
registerTermsOverlay(termsOverlay, renderTerms);

/* ─── Privacy overlay ──────────────────── */
const privacyOverlay = $('#privacy-overlay');
const privacyBody = $('#privacy-body');
const privacySections = [
	{ t: 'priv1t', p: ['priv1', 'priv1details'] },
	{ t: 'priv2t', p: ['priv2a', 'priv2b', 'priv2c'] },
	{ t: 'priv3t', p: ['priv3'] },
	{ t: 'priv4t', p: ['priv4a', 'priv4b', 'priv4c', 'priv4d'] },
	{ t: 'priv5t', p: ['priv5'] },
	{ t: 'priv6t', p: ['priv6'] },
	{ t: 'priv7t', p: ['priv7'] },
	{ t: 'priv8t', p: ['priv8'] },
	{ t: 'priv9t', p: ['priv9'] },
	{ t: 'priv10t', p: ['priv10'] },
];

export function renderPrivacy() {
	const l = lang;
	privacyBody.innerHTML = privacySections.map(s => {
		const heading = T[l]?.[s.t] || s.t;
		const paras = s.p.map(k => {
			const text = (T[l]?.[k] || k).replace(/\n/g, '<br>');
			return '<p style="margin:0.5rem 0;color:var(--on-surface-secondary);">' + text + '</p>';
		}).join('');
		return '<div style="margin-bottom:1.75rem;"><h3 style="font-family:var(--font-heading);font-size:1.1rem;color:var(--on-surface);margin-bottom:0.5rem;">' + heading + '</h3>' + paras + '</div>';
	}).join('');
}

export function openPrivacy() {
	renderPrivacy();
	privacyOverlay.style.display = 'block';
	document.body.style.overflow = 'hidden';
}
export function closePrivacy() {
	privacyOverlay.style.display = 'none';
	document.body.style.overflow = '';
	if (location.hash === '#privacy') history.pushState(null, '', location.pathname + location.search);
}

$('#privacy-close').addEventListener('click', closePrivacy);
privacyOverlay.addEventListener('click', e => { if (e.target === privacyOverlay) closePrivacy(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape' && privacyOverlay.style.display === 'block') closePrivacy(); });

// Register with i18n so applyLang can re-render when open
registerPrivacyOverlay(privacyOverlay, renderPrivacy);

/* ─── Hash routing ──────────────────────── */
window.addEventListener('hashchange', () => {
	if (location.hash === '#terms') { openTerms(); closePrivacy(); }
	else if (location.hash === '#privacy') { openPrivacy(); closeTerms(); }
	else { closeTerms(); closePrivacy(); }
});
if (location.hash === '#terms') setTimeout(openTerms, 100);
if (location.hash === '#privacy') setTimeout(openPrivacy, 100);
